import React from 'react';
import { Webchat, WebchatProvider, Fab, getClient } from '@botpress/webchat';
import '../index.css';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

const clientId = 'd52abac7-6330-4b96-a9f2-f8b476dc73e0';

const config = {
    composerPlaceholder: 'What would you like to know?',
    botName: 'Exam Prep Assistant',
    botAvatar: 'http://contractortestla.com/wp-content/uploads/2019/02/favicon.png',
    botDescription: `Need help understanding how an answer was obtained? Or have a question related to the practice test you're taking? I'm here to assist! Just ask away, and I'll guide you through the details!`,
    email: {
        title: 'info@contractortestla.com',
        link: 'mailto:info@contractortestla.com',
    },
    phone: {
        title: '+1-800-432-9930',
        link: 'tel:+1-800-432-9930',
    },
    website: {
        title: 'https://contractortestla.com',
        link: 'https://contractortestla.com',
    },
    termsOfService: {
        title: 'Terms of service',
        link: 'https://contractortestla.com/wpautoterms/terms-and-conditions/',
    },
    privacyPolicy: {
        title: 'Privacy policy',
        link: 'https://contractortestla.com/wpautoterms/privacy-policy/',
    },
};

const ChatBot = ({ toggleWebchat, chatBotOpen }) => {
    const client = getClient({ clientId });

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '10px',
                right: '10px',
                zIndex: 9999,
            }}
        >
            <WebchatProvider client={client} configuration={config}>
                <Fab onClick={toggleWebchat} />
                <div
                    style={{
                        display: chatBotOpen ? 'block' : 'none',
                        position: 'fixed',
                        bottom: '-15px',
                        right: '10px',
                        width: '360px',
                        height: '500px',
                        zIndex: 9999,
                        borderRadius: '10px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                        contain: 'content' // Add containment to prevent layout thrashing
                    }}
                >
                    <div 
                        style={{ 
                            position: 'absolute', 
                            top: '15px', 
                            right: '15px', 
                            zIndex: 10000,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <IconButton 
                            onClick={toggleWebchat}
                            sx={{
                                color: 'white',
                                backgroundColor: '#ff5e1c',
                                width: '32px',
                                height: '32px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    backgroundColor: '#e65419',
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
                                }
                            }}
                            size="medium"
                            aria-label="Close AI assistant"
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </div>
                    <Webchat />
                </div>
            </WebchatProvider>
        </div>
    );
};

export default ChatBot;
